import { askApi, employeeUrl } from '../endpoints';

export function getEmployees() {
    return new Promise((resolve) => {
        askApi.get(employeeUrl).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function addEmployee(payload) {
    return new Promise((resolve) => {
        askApi.post(employeeUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function inviteEmployee(payload) {
    return new Promise((resolve) => {
        askApi.post(employeeUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function importEmployees(payload) {
    return new Promise((resolve) => {
        askApi
            .post(`${employeeUrl}/attachment`, payload, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            });
    });
}

export function updateEmployee(id, payload) {
    return new Promise((resolve) => {
        askApi.put(`${employeeUrl}/${id}`, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function deleteEmployee(id, payload) {
    return new Promise((resolve) => {
        askApi.delete(`${employeeUrl}/${id}`, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
